import { render, staticRenderFns } from "./c_home_checkbox.vue?vue&type=template&id=5ed5018f&scoped=true"
import script from "./c_home_checkbox.vue?vue&type=script&lang=js"
export * from "./c_home_checkbox.vue?vue&type=script&lang=js"
import style0 from "./c_home_checkbox.vue?vue&type=style&index=0&id=5ed5018f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed5018f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ed5018f')) {
      api.createRecord('5ed5018f', component.options)
    } else {
      api.reload('5ed5018f', component.options)
    }
    module.hot.accept("./c_home_checkbox.vue?vue&type=template&id=5ed5018f&scoped=true", function () {
      api.rerender('5ed5018f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/components/mobileFormConfig/c_home_checkbox.vue"
export default component.exports